function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.571 15.3592L8.26602 13.6713L11.384 16.0097L9.98409 18.1732C9.4949 18.9292 8.83767 19.562 8.06366 20.0222L3.22558 22.8989C2.55957 23.2949 1.69942 23.0901 1.28342 22.4363L1.19525 22.2978C0.886024 21.8119 0.955784 21.1764 1.36306 20.7691C1.4179 20.7143 1.47781 20.6647 1.54198 20.6212L5.44781 17.9708C6.39625 17.3272 7.13459 16.419 7.571 15.3592Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2906 2.61449L16.2218 3.59156C16.5024 3.68511 16.7963 3.7328 17.0921 3.7328H17.2734C17.7513 3.7328 18.2163 3.88781 18.5986 4.17455C19.2027 4.62765 19.5335 5.35799 19.4756 6.11094L19.4408 6.56367C19.3969 7.13323 19.1933 7.67887 18.8533 8.13789L16.0016 11.9877C15.712 12.3786 15.7961 12.9306 16.1889 13.2177L19.2013 15.419C19.9128 15.939 20.0058 16.9657 19.3992 17.605L14.2471 23.0356C13.7383 23.572 12.8947 23.6053 12.3451 23.1106C11.8062 22.6256 11.7409 21.8037 12.1964 21.2397L14.8934 17.9006C15.2099 17.5088 15.132 16.9315 14.723 16.6375L9.96705 13.2192C9.56813 12.9325 9.48255 12.374 9.77732 11.981L13.6936 6.75922C14.074 6.25201 13.8071 5.52117 13.1893 5.3786L12.8867 5.30878C12.2813 5.16907 11.6534 5.15752 11.0433 5.27484L8.0672 5.84717C7.41352 5.97288 6.77556 5.56584 6.61411 4.92005C6.44904 4.25976 6.84091 3.58836 7.49702 3.40736L10.6253 2.5444C11.501 2.30282 12.4288 2.32722 13.2906 2.61449Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7135 8.89707L20.5429 8.21485L18.9443 10.2131C18.5088 10.7575 18.4968 11.5276 18.9151 12.0854C19.2038 12.4703 19.6569 12.6969 20.1381 12.6969H23.7583C24.5655 12.6969 25.2199 12.0426 25.2199 11.2354C25.2199 10.4282 24.5655 9.77383 23.7583 9.77383H21.8364C21.3053 9.77383 20.8423 9.41235 20.7135 8.89707Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 21.9987,
  cy: 2.66667,
  rx: 2.66667,
  ry: 2.66667,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 25.9987,
  cy: 21.3327,
  rx: 2.66667,
  ry: 2.66667,
  fill: "black"
});

var SvgDribblingIcon = function SvgDribblingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDribblingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DribblingIcon.18a5e5cf.svg";
export { ForwardRef as ReactComponent };